<template>
  <div class="home page-shell">
    <section class="hero">
      <video class="hero__video" :src="videoUrl" muted autoplay loop playsinline></video>
      <div class="hero__overlay"></div>
      <div class="hero__grid"></div>
      <div class="hero__content">
        <p class="hero__kicker">Yufei Intelligent · Cloud Access Platform</p>
        <h1>让每一次通行，都更快、更稳、更智能</h1>
        <p class="hero__desc">
          聚合云端智慧通行能力，宇飞智能深耕智慧停车、智能人行与精密门控；以全场景物联网生态，构筑城市级智慧运营平台。
        </p>
        <div class="hero__actions">
          <router-link class="primary-btn" to="/product">查看产品方案</router-link>
          <router-link class="ghost-btn" to="/case">浏览经典案例</router-link>
        </div>
      </div>
      <div class="stats-panel">
        <div v-for="item in site.stats" :key="item.label" class="stat-item">
          <strong>{{ item.value }}<span>{{ item.suffix }}</span></strong>
          <p>{{ item.label }}</p>
        </div>
      </div>
    </section>

    <section class="solutions section-wrap">
      <div class="section-head">
        <div>
          <p class="section-kicker">SOLUTIONS</p>
          <h2 class="section-title">云端智慧通行解决方案</h2>
        </div>
        <p class="section-desc">
          面向停车场、园区、酒店、商业综合体和城市公共空间，将前端设备、云端平台与运营服务打通。
        </p>
      </div>

      <div class="solution-grid">
        <article v-for="item in site.solutions" :key="item.title" class="solution-card">
          <span>{{ item.tag }}</span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
    </section>

    <section class="product-band">
      <div class="section-wrap product-band__inner">
        <div class="product-copy">
          <p class="section-kicker">PRODUCT MATRIX</p>
          <h2 class="section-title">从前端设备到云端平台的一体化产品矩阵</h2>
          <p class="section-desc">
            围绕“车、人、场、云”四类核心对象，提供识别、控制、引导、运营和数据分析能力。
          </p>
          <router-link class="primary-btn" to="/product">进入产品中心</router-link>
        </div>
        <div class="product-matrix">
          <div v-for="item in site.productHighlights" :key="item" class="matrix-item">{{ item }}</div>
        </div>
      </div>
    </section>

    <section class="cases section-wrap">
      <div class="section-head">
        <div>
          <p class="section-kicker">PROJECTS</p>
          <h2 class="section-title">经典案例</h2>
        </div>
        <router-link class="text-link" to="/case">查看更多案例</router-link>
      </div>

      <div class="case-grid">
        <router-link
          v-for="item in featuredCases"
          :key="item.id"
          class="case-card"
          :to="{ name: 'casedetails', params: item }"
        >
          <div class="case-card__img" v-lazy:background-image="item.Img"></div>
          <div class="case-card__body">
            <span>{{ item.CreateTime }}</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </div>
        </router-link>
      </div>
    </section>

    <section class="honor-band">
      <div class="section-wrap honor-band__inner">
        <div>
          <p class="section-kicker">HONORS</p>
          <h2 class="section-title">行业认可与资质背书</h2>
          <p class="section-desc">用长期研发和交付积累，支撑更稳定的智慧通行项目落地。</p>
        </div>
        <div class="honor-strip">
          <div v-for="item in featuredHonors" :key="item.Remark" class="honor-item">
            <img v-lazy="item.Img" :alt="item.Remark" />
            <p>{{ item.Remark }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="news section-wrap">
      <div class="section-head">
        <div>
          <p class="section-kicker">NEWS</p>
          <h2 class="section-title">新闻动态</h2>
        </div>
        <router-link class="text-link" to="/news">查看更多新闻</router-link>
      </div>

      <div class="news-grid">
        <router-link
          v-for="item in site.news"
          :key="item.id"
          class="news-card"
          :to="{ name: 'newsdetails', params: item }"
        >
          <img v-lazy="item.Img" :alt="item.title" />
          <div>
            <span>{{ item.CreateTime }}</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </div>
        </router-link>
      </div>
    </section>

    <section class="cta">
      <div class="section-wrap cta__inner">
        <div>
          <p class="section-kicker">CONTACT</p>
          <h2>让项目从“有人值守”走向“云端运营”</h2>
        </div>
        <router-link class="primary-btn primary-btn--light" to="/goin">了解宇飞智能</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import site from "../static/siteData";

export default {
  name: "Home",
  data() {
    return {
      site,
      videoUrl: "https://web.wlyk.com/static/yufei/1.mp4"
    };
  },
  computed: {
    featuredCases() {
      return this.site.cases.slice(0, 3);
    },
    featuredHonors() {
      return this.site.honors.slice(0, 4);
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  overflow: hidden;
}

.hero {
  position: relative;
  min-height: calc(100vh - 72px);
  overflow: hidden;
  display: flex;
  align-items: center;
  color: #fff;
  background: #071a35;
}

.hero__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(4, 17, 42, 0.92) 0%, rgba(5, 34, 83, 0.72) 52%, rgba(4, 17, 42, 0.38) 100%),
    radial-gradient(circle at 68% 30%, rgba(22, 119, 255, 0.5), transparent 34%);
}

.hero__grid {
  position: absolute;
  inset: 0;
  opacity: 0.18;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.18) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.18) 1px, transparent 1px);
  background-size: 46px 46px;
}

.hero__content {
  position: relative;
  z-index: 1;
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
  padding: 84px 0 170px;
}

.hero__kicker {
  color: #8be8ff;
  font-size: 13px;
  font-weight: 800;
}

h1 {
  max-width: 820px;
  margin-top: 18px;
  font-size: 58px;
  line-height: 1.12;
  font-weight: 900;
}

.hero__desc {
  max-width: 680px;
  margin-top: 22px;
  color: #d6e6ff;
  font-size: 18px;
  line-height: 1.9;
}

.hero__actions {
  margin-top: 34px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.primary-btn,
.ghost-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 24px;
  border-radius: 99px;
  font-size: 15px;
  font-weight: 800;
}

.primary-btn {
  color: #fff;
  background: linear-gradient(135deg, #1677ff, #00c2ff);
  box-shadow: 0 16px 38px rgba(22, 119, 255, 0.36);
}

.primary-btn--light {
  color: #1677ff;
  background: #fff;
  box-shadow: 0 16px 38px rgba(0, 30, 80, 0.16);
}

.ghost-btn {
  color: #eaf5ff;
  border: 1px solid rgba(255, 255, 255, 0.38);
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.stats-panel {
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: 34px;
  transform: translateX(-50%);
  width: min(1200px, calc(100% - 40px));
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 18px;
  background: rgba(5, 26, 63, 0.7);
  backdrop-filter: blur(18px);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.24);
}

.stat-item {
  padding: 24px 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.stat-item:last-child {
  border-right: 0;
}

.stat-item strong {
  color: #fff;
  font-size: 30px;
  line-height: 1;
}

.stat-item strong span {
  margin-left: 2px;
  color: #8be8ff;
  font-size: 13px;
}

.stat-item p {
  margin-top: 10px;
  color: #bcd4f6;
  font-size: 14px;
}

.solutions,
.cases,
.news {
  padding: 86px 0;
}

.section-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
  margin-bottom: 34px;
}

.section-head .section-desc {
  max-width: 520px;
}

.solution-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.solution-card {
  position: relative;
  min-height: 260px;
  overflow: hidden;
  padding: 30px;
  border: 1px solid rgba(22, 119, 255, 0.12);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
}

.solution-card::after {
  content: "";
  position: absolute;
  right: -70px;
  top: -70px;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(22, 119, 255, 0.2), transparent 68%);
}

.solution-card span {
  color: #1677ff;
  font-size: 12px;
  font-weight: 900;
}

.solution-card h3 {
  margin-top: 24px;
  color: #071a35;
  font-size: 24px;
}

.solution-card p {
  margin-top: 16px;
  color: #64748b;
  font-size: 15px;
  line-height: 1.8;
}

.product-band,
.honor-band {
  padding: 86px 0;
  background:
    linear-gradient(135deg, rgba(5, 18, 45, 0.96), rgba(7, 54, 123, 0.94)),
    radial-gradient(circle at 82% 14%, rgba(0, 212, 255, 0.22), transparent 28%);
}

.product-band .section-title,
.honor-band .section-title {
  color: #fff;
}

.product-band .section-desc,
.honor-band .section-desc {
  color: #bcd4f6;
}

.product-band__inner,
.honor-band__inner {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 58px;
  align-items: center;
}

.product-copy .primary-btn {
  margin-top: 26px;
}

.product-matrix {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.matrix-item {
  min-height: 96px;
  display: flex;
  align-items: center;
  padding: 22px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.text-link {
  color: #1677ff;
  font-weight: 800;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.case-card,
.news-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.case-card:hover,
.news-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.14);
}

.case-card__img {
  height: 230px;
  background-position: center;
  background-size: cover;
}

.case-card__body {
  padding: 24px;
}

.case-card span,
.news-card span {
  color: #1677ff;
  font-size: 13px;
  font-weight: 800;
}

.case-card h3,
.news-card h3 {
  margin-top: 10px;
  color: #071a35;
  font-size: 21px;
}

.case-card p,
.news-card p {
  margin-top: 12px;
  color: #62728a;
  font-size: 14px;
  line-height: 1.8;
}

.honor-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.honor-item {
  min-height: 210px;
  padding: 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.honor-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 10px;
  background: #fff;
}

.honor-item p {
  margin-top: 12px;
  color: #e8f3ff;
  font-size: 13px;
  text-align: center;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.news-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.news-card div {
  padding: 20px;
}

.news-card h3 {
  font-size: 18px;
  line-height: 1.4;
}

.cta {
  padding: 58px 0;
  color: #fff;
  background: linear-gradient(135deg, #1677ff, #00b7ff);
}

.cta__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.cta .section-kicker {
  color: #dff7ff;
}

.cta h2 {
  margin-top: 10px;
  font-size: 32px;
}

@media (max-width: 960px) {
  .hero {
    min-height: 760px;
  }

  h1 {
    font-size: 42px;
  }

  .stats-panel,
  .solution-grid,
  .case-grid,
  .news-grid,
  .product-band__inner,
  .honor-band__inner {
    grid-template-columns: 1fr 1fr;
  }

  .stats-panel {
    position: relative;
    left: auto;
    bottom: auto;
    transform: none;
    width: min(100% - 40px, 720px);
    margin: -130px auto 0;
  }

  .hero__content {
    padding-bottom: 180px;
  }

  .section-head,
  .cta__inner {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .hero {
    min-height: auto;
    display: block;
  }

  .hero__content {
    width: calc(100% - 24px);
    padding: 76px 0 150px;
  }

  h1 {
    font-size: 34px;
  }

  .hero__desc {
    font-size: 16px;
  }

  .stats-panel,
  .solution-grid,
  .case-grid,
  .news-grid,
  .product-band__inner,
  .honor-band__inner,
  .product-matrix,
  .honor-strip {
    grid-template-columns: 1fr;
  }

  .stats-panel {
    width: calc(100% - 24px);
    margin-top: -90px;
  }

  .stat-item {
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .solutions,
  .cases,
  .news,
  .product-band,
  .honor-band {
    padding: 62px 0;
  }
}
</style>
